<template>
  <v-data-table
    :headers="headers"
    :items="filteredItems"
    sort-desc
    item-key="paysystem_id"
    calculate-widths
    class="paysystem-dt"
    height="calc(100vh - 96px)"
    fixed-header
    :loading="loading"
    :footer-props="{'items-per-page-options': [25, 50, 100, -1]}"
    :items-per-page="50"
  >

    <template v-slot:top>
      <update-form v-model="dialog" :item="item" :refresh="load" />
    </template>

    <template v-slot:footer.page-text="{ pageStart , pageStop , itemsLength }">
      {{ pageStart }} - {{ pageStop }} of {{ itemsLength }}
      <v-btn @click="load" icon style="margin-right: -35px;">
        <v-icon>refresh</v-icon>
      </v-btn>
    </template>

    <template v-slot:body.prepend>
      <tr v-if="Object.keys(filters).length > 0" class="paysystem-dt-filter-row v-data-table-header grey lighten-3">
        <td
          v-for="header in headers"
          :key="header.text"
        >
          <v-autocomplete
            v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
            hide-details
            dense
            small
            multiple
            clearable
            persistent-hint
            single-line
            class="paysystem-filter-select mt-0"
            :items="filters[header.value].values || columnValueList(header.value)"
            :style="{width: (filters[header.value] || {width: false}).width}"
            v-model="filters[header.value].data"
          ></v-autocomplete>
          <v-text-field
            dense
            class="paysystem-filter-textfield mt-0"
            v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
            v-model="filters[header.value].data"
            :style="{width: (filters[header.value] || {width: false}).width}"
            hide-details
          ></v-text-field>
        </td>
      </tr>
    </template>

    <template v-slot:header.action="{ item }">
      <v-row class="mx-auto text-center" style="width: 60px">
        <v-badge
          bordered
          bottom
          left
          color="error"
          :content="keys(editItems).length"
          :value="keys(editItems).length"
          overlap
        >
          <v-btn
            text
            title="Save All"
            class="px-0"
            style="min-width: 36px"
            :disabled="keys(editItems).length == 0"
            @click="save(item)"
          >
            <v-icon>mdi-content-save-all</v-icon>
          </v-btn>
        </v-badge>
        <v-icon @click="edit(newItem)">mdi-plus</v-icon>
      </v-row>
    </template>

    <template v-slot:item.settings.request_url="{ item }">
      {{ item.settings.request_url }}
    </template>
    <template v-slot:item.action="{ item }">
      <div style="width: 50px" class="float-right">
        <v-icon v-if="editItems[item.paysystem_id]" small @click="toggleEdit(item)">mdi-close</v-icon>
        <v-icon v-if="!editItems[item.paysystem_id]" small @click="toggleEdit(item)">edit</v-icon>
        <v-icon v-if="!editItems[item.paysystem_id]" small @click="edit(item)">mdi-cog-outline</v-icon>
      </div>
    </template>

    <template v-slot:item.row_num="{ item }">
      <span class="row_num"></span>
    </template>

    <template v-slot:item.settings.request_url="{ item }">
      <div class="text-overflow" style="max-width: 310px">{{ item.settings.request_url }}</div>
    </template>
    <template v-slot:item.settings.secret_key="{ item }">
      <div class="text-overflow" style="max-width: 250px">{{ item.settings.secret_key }}</div>
    </template>
    <template v-slot:item.settings.merchant_id="{ item }">
      <div class="text-overflow" style="max-width: 200px">{{ item.settings.merchant_id }}</div>
    </template>

    <template v-slot:item.name="{ item }">
      <template v-if="editItems[item.paysystem_id]">
        <v-text-field
          class="paysystem-filter-textfield"
          v-model="editItems[item.paysystem_id].name"
          hide-details
          dense
        />
      </template>
      <template v-else>
        {{ item.name }}
      </template>
    </template>
    <template v-slot:item.comments="{ item }">
      <template v-if="editItems[item.paysystem_id]">
        <v-text-field
          class="paysystem-filter-textfield"
          v-model="editItems[item.paysystem_id].comments"
          hide-details
          dense
        />
      </template>
      <template v-else>
        {{ item.comments }}
      </template>
    </template>
  </v-data-table>
</template>

<style>

  .paysystem-dt-filter-row .paysystem-filter-textfield {
    padding-top: 6px;
  }

  .paysystem-dt .v-btn-toggle .v-btn {
    min-height: 36px !important;
    height: 36px !important;
  }

  .paysystem-dt-filter-row .v-input,
  .paysystem-dt .paysystem-filter-textfield {
    font-size: 0.875rem;
  }

  .paysystem-dt-filter-row td {
    height: 33px !important;
  }

  .paysystem-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .paysystem-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .paysystem-dt.v-data-table td,
  .paysystem-dt.v-data-table th {
    padding: 0 8px !important;
  }

  .paysystem-dt.v-data-table td .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .paysystem-dt .v-data-footer__select .v-select {
    margin: 5px 0 10px 34px;
  }

  .paysystem-dt .v-data-footer {
    justify-content: center;
  }
</style>

<script>
  import { debounce, filter, get, toString, sortBy, cloneDeep, map, clone, toArray, omit, keyBy } from 'lodash'
  import { API } from '@/utils/api'

  export default {

    components: {
      UpdateForm: () => import('@/components/settings/paysystem/UpdateForm'),
    },

    data: () => ({
      editItems: {},
      saveMenu: false,
      dialog: false,
      newItem: {
        settings: {}
      },
      item: {},
      selected: [],
      paysystems: [],
      loading: false,
      filters: {
        paysystem: { data: [], type: 'select' },
        name: { data: [], type: 'select' },
        comments: { data: [], type: 'text' },
      },
      filtersD: {},
      headers: [
        // { text: '#', value: 'row_num', sortable: false },
        { text: 'ID', value: 'paysystem_id' },
        { text: 'Name', value: 'name' },
        { text: 'Comment', value: 'comments' },
        { text: 'URL', value: 'settings.request_url' },
        { text: 'MerchantID', value: 'settings.merchant_id' },
        { text: 'Secret', value: 'settings.secret_key' },
        { text: '', value: 'action', sortable: false },
      ],
      items: []
    }),

    mounted () {
      this.load()
    },

    watch: {
      filters: {
        handler: debounce(function () {
          this.filtersD = this.filters
        }, 800),
        deep: true,
      },
    },

    computed: {
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filtersD).every(f => {
            try {
              if (this.filtersD[f].data.length > 1 && typeof this.filtersD[f].data == 'string' && this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filtersD[f].data
                if (this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filtersD[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filtersD[f].data.length < 1
              || ((this.filtersD[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filtersD[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filtersD[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    methods: {
      keys (obj) {
        if (!obj) return {}
        return Object.keys(obj)
      },

      columnValueList (val) {
        return sortBy(filter(this.items.map(d => get(d, val)), (i) => i))
      },

      currencyConvertObj2Arr (o) {
        let out = []
        for (let k in o) {
          out.push(k + ' -> ' + o[k])
        }

        return out
      },
      toggleEdit (item) {
        item.edit = !item.edit
        if (!item.edit) {
          item = clone(item.init)

          delete this.editItems[item.paysystem_id.toString()]
        } else {
          if (!item.init) {
            item.init = cloneDeep(item)
          }
          this.editItems[item.paysystem_id] = item
        }

        this.editItems = cloneDeep(this.editItems)
      },
      edit (item) {
        this.dialog = true
        this.item = cloneDeep(item)
      },
      load () {
        this.loading = true
        return API.call('/$v/paysystem/list.json', {}).then(resp => {
          this.editItems = {}
          this.selected = []
          this.items = resp.data
        }).finally(() => {
          this.loading = false
        })
      },

      async save (message = 'Save paysystems', saveAs = false) {
        let items = toArray(this.editItems)
        if (items.length == 0) return

        if (saveAs) {
          items = map(items, item => omit(item, 'paysystem_id'))
        }

        let buttons = [
          { text: 'Save', value: true, class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]

        let confirmRes = await this.$root.$confirm('Confirm', message, { width: 515, buttons })

        if (!confirmRes) {
          return
        }

        this.loading = true
        return API.call('/$v/paysystem/update.json', { items: items }).then(resp => {

          this.$notification.show = true
          this.$notification.message = 'Paysystems updated'
          this.$notification.type = 'success'

          return this.load()
        }).finally(() => {
          this.loading = false
        })
      },

      async saveAs () {
        return this.save('Save paysystems as new', true)
      }
    },

  }
</script>

